module.exports = __webpack_public_path__ + "media/panicsound.dc828a04.wav";